import { Provider } from '@angular/core';
import { THEME_PREFERENCE } from '@shared/di/theme-preference.token';
import { ThemePreferenceService } from './theme-preference.service';

/** Binds the shared dark-mode flag to the data slice. Register at the root injector. */
export function provideThemePreference(): Provider {
  return { provide: THEME_PREFERENCE, useExisting: ThemePreferenceService };
}
